import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import InputField from "../../ui/form/InputField";
import apiRequest from "../../../utils/admin/apiRequest";
import toast from "react-hot-toast";

const SeoSetting = () => {
  const setting = useSelector((state) => state.globalState.siteSetting);
  const seoSetting = setting?.seo_settings || {};

  const defaultSeoSettings = {
    meta_title: seoSetting?.meta_title || "",
    meta_description: seoSetting?.meta_description || "",
    meta_keywords: seoSetting?.meta_keywords || "",
  };

  const [seoSettings, setSeoSettings] = useState(defaultSeoSettings);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (setting?.seo_settings) {
      setSeoSettings((prev) => ({
        ...prev,
        ...setting.seo_settings,
      }));
    }
  }, [setting]);

  const handleSeoSettingsChange = (e) => {
    const { name, value } = e.target;
    setSeoSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await apiRequest.updateSetting({
        data: { seo_settings: seoSettings },
      });
      toast.success(
        response?.data?.message || "SEO settings updated successfully."
      );
    } catch (error) {
      console.error(error);
      toast.error("Failed to update SEO settings.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="space-y-4 bg-white p-4 rounded" onSubmit={handleSubmit}>
      <h2 className="text-lg font-semibold text-gray-700">SEO Settings</h2>

      <InputField
        label="Meta Title"
        id="meta_title"
        name="meta_title"
        value={seoSettings.meta_title}
        onChange={handleSeoSettingsChange}
      />
      <InputField
        label="Meta Description"
        id="meta_description"
        name="meta_description"
        value={seoSettings.meta_description}
        onChange={handleSeoSettingsChange}
      />
      <InputField
        label="Meta Keywords"
        id="meta_keywords"
        name="meta_keywords"
        value={seoSettings.meta_keywords}
        onChange={handleSeoSettingsChange}
      />

      <button
        type="submit"
        disabled={loading}
        className="px-4 py-2 text-sm text-white bg-primary rounded hover:bg-primaryDark"
      >
        {loading ? "Saving..." : "Update Settings"}
      </button>
    </form>
  );
};

export default SeoSetting;
